(() => {
  // Texte in der Sprache der Seite: window.cmT.cm aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt cm). Fehlt cmT oder
  // ein Schlüssel, gilt der deutsche Text hier; {name} wird ersetzt.
  const cmTexts = (window.cmT && window.cmT.cm) || {};
  const tx = (key, de, vars) => {
    const own = cmTexts[key];
    const text = typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
    return vars ? text.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all)) : text;
  };
  const cmCommon = (window.cmT && window.cmT.common) || {};
  const dateLocale = /^[a-z]{2}-[A-Z]{2}$/.test(cmCommon.date_locale || '') ? cmCommon.date_locale : 'de-DE';
  function initPrices(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const model = root.querySelector('[data-model]');
    const repair = root.querySelector('[data-repair]');
    const result = root.querySelector('[data-price]');
    const repairOptions = root.querySelector('[data-repair-options]');
    const repairChoices = root.querySelector('[data-repair-choices]');
    const money = new Intl.NumberFormat(window.CMMoney ? window.CMMoney.locale : 'de-DE', { style: 'currency', currency: 'EUR' });
    const option = (label, value) => new Option(label, value);
    const repairIcon = value => {
      const key = value.toLocaleLowerCase('de');
      if (key.includes('batter')) return '<svg viewBox="0 0 24 24"><rect x="4" y="6" width="15" height="12" rx="2"/><path d="M19 10h2v4h-2M10 9l-2 4h3l-1 3 5-6h-3l1-1Z"/></svg>';
      if (key.includes('display')) return '<svg viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="3"/><path d="M9 18h6"/></svg>';
      if (key.includes('mittel')) return '<svg viewBox="0 0 24 24"><rect x="7" y="7" width="10" height="10" rx="2"/><path d="M9 2v3m6-3v3M9 19v3m6-3v3M2 9h3m-3 6h3m14-6h3m-3 6h3M10 10h4v4h-4z"/></svg>';
      if (key.includes('rückglas')) return '<svg viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="3"/><circle cx="12" cy="6" r="1"/><path d="m12 10-2 3 3 1-2 4"/></svg>';
      if (key.includes('kamera')) return '<svg viewBox="0 0 24 24"><path d="M4 7h4l2-2h4l2 2h4v12H4z"/><circle cx="12" cy="13" r="3"/></svg>';
      if (key.includes('gesamt')) return '<svg viewBox="0 0 24 24"><rect x="6" y="2" width="12" height="20" rx="3"/><path d="M9 6h6M9 18h6"/></svg>';
      return '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M9.7 9a2.5 2.5 0 0 1 4.8 1c0 2-2.5 2.2-2.5 4M12 18h.01"/></svg>';
    };
    const setStage = stage => { root.dataset.stage = String(stage); };
    const setSelectedRepair = value => repairChoices.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === value)));
    const renderRepairChoices = values => {
      repairChoices.replaceChildren();
      [...values, tx('other_problem', 'Anderes Problem / unsicher')].forEach((value, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.value = index === values.length ? '__other' : value;
        button.setAttribute('aria-pressed', 'false');
        const icon = document.createElement('span'); icon.className = 'cm-repair-choice-icon'; icon.setAttribute('aria-hidden', 'true'); icon.innerHTML = repairIcon(value);
        const label = document.createElement('span'); label.textContent = value;
        button.append(icon, label);
        button.addEventListener('click', () => {
          repair.value = button.dataset.value;
          repair.dispatchEvent(new Event('change'));
        });
        repairChoices.append(button);
      });
    };
    // Aktuelle Preise aus CompuHub (dieselbe Liste wie Ivy, /apps/compuhub/repair/v1/prices), 30 Minuten je Browser gemerkt;
    // nicht erreichbar, falsch oder leer → die feste Kopie im Theme (cm-repair-prices.json).
    const stand = root.querySelector('[data-price-stand]');
    const liveKey = 'cm-repair-prices-live-v1';
    const liveTtl = 30 * 60 * 1000;
    const usable = data => Boolean(data) && Array.isArray(data.rows) && data.rows.some(row => row && row.device === 'iPhone' && typeof row.model === 'string' && typeof row.repair === 'string');
    const getJson = (url, ms) => {
      const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      const timer = ctrl ? setTimeout(() => ctrl.abort(), ms) : null;
      return fetch(url, { headers: { accept: 'application/json' }, credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(response => { if (!response.ok) throw new Error('Price feed unavailable'); return response.json(); })
        .finally(() => { if (timer) clearTimeout(timer); });
    };
    const livePrices = () => {
      try {
        const kept = JSON.parse(localStorage.getItem(liveKey) || 'null');
        if (kept && Date.now() - kept.at < liveTtl && usable(kept.data)) return Promise.resolve({ data: kept.data, live: true });
      } catch (error) { /* ohne Speicher: frisch laden */ }
      if (!root.dataset.liveSource) return Promise.reject(new Error('No live source'));
      return getJson(root.dataset.liveSource, 5000).then(data => {
        if (!data || data.ok !== true || !usable(data)) throw new Error('Live price feed unusable');
        try { localStorage.setItem(liveKey, JSON.stringify({ at: Date.now(), data })); } catch (error) { /* egal */ }
        return { data, live: true };
      });
    };
    const fixedPrices = () => getJson(root.dataset.source, 10000).then(data => ({ data, live: false }));
    const standDate = value => { const d = new Date(value); return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString(dateLocale, { day: '2-digit', month: '2-digit', year: 'numeric' }); };
    livePrices().catch(fixedPrices).then(({ data, live }) => {
      if (!Array.isArray(data.rows) || !data.rows.length) throw new Error('Price feed empty');
      if (stand) {
        const when = standDate(live ? data.updated_at : data.captured_at);
        if (live) stand.textContent = when ? tx('stand_live_date', 'Aktuelle Preise aus unserer Werkstatt, Stand {date}.', { date: when }) : tx('stand_live', 'Aktuelle Preise aus unserer Werkstatt.');
        else if (when) stand.textContent = tx('stand_fixed', 'Preisliste vom {date}.', { date: when });
      }
      const rows = data.rows.filter(row => row.device === 'iPhone');
      model.replaceChildren(option(tx('choose_model', 'Modell auswählen'), ''));
      [...new Set(rows.map(row => row.model))].sort((a,b)=>a.localeCompare(b,'de',{numeric:true})).forEach(value => model.add(option(`iPhone ${value}`, value)));
      model.disabled = false;
      model.addEventListener('change', () => {
        repair.replaceChildren(option(tx('choose_repair', 'Reparatur auswählen'), ''));
        const repairs = [...new Set(rows.filter(row => row.model === model.value).map(row => row.repair))];
        repairs.forEach(value => repair.add(option(value, value)));
        repair.add(option(tx('other_problem', 'Anderes Problem / unsicher'), '__other'));
        repair.disabled = !model.value;
        repairOptions.hidden = !model.value;
        renderRepairChoices(repairs);
        setStage(model.value ? 2 : 1);
        result.textContent = model.value ? tx('pick_repair', 'Wähle die gewünschte Reparatur.') : tx('pick_model', 'Wähle dein iPhone, um zu starten.');
      });
      repair.addEventListener('change', () => {
        const row = rows.find(row => row.model === model.value && row.repair === repair.value);
        setSelectedRepair(repair.value);
        setStage(repair.value ? 3 : 2);
        result.replaceChildren();
        if (!repair.value) { result.textContent = tx('pick_repair', 'Wähle die gewünschte Reparatur.'); return; }
        if (!row || !Number.isFinite(row.price) || row.conflict) {
          result.textContent = tx('price_after_check', 'Preis nach Prüfung. Wir beraten dich und klären die Kosten vor der Reparatur.');
          return;
        }
        const price = document.createElement('strong'); price.textContent = money.format(row.price);
        const label = document.createElement('span'); label.textContent = tx('price_label', 'iPhone {model} · {repair} · inkl. MwSt.', { model: row.model, repair: row.repair });
        result.append(price,label);
      });
    }).catch(() => {
      model.replaceChildren(option(tx('unavailable', 'Preise derzeit nicht verfügbar'), ''));
      model.disabled = true; repair.disabled = true;
      result.textContent = tx('load_failed', 'Die Preisliste konnte nicht geladen werden. Bitte ruf uns unter 07541 9203-0 an oder buche einen Termin.');
    });
  }
  const init = () => document.querySelectorAll('[data-repair-prices]').forEach(initPrices);
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.cm-mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
})();
